import { render, staticRenderFns } from "./SubmenuModern.vue?vue&type=template&id=2c43745c&scoped=true&"
import script from "./SubmenuModern.vue?vue&type=script&lang=js&"
export * from "./SubmenuModern.vue?vue&type=script&lang=js&"
import style0 from "./SubmenuModern.vue?vue&type=style&index=0&id=2c43745c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c43745c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Icon: require('/codebuild/output/src2284964156/src/med-el-hearpeers/components/Icon/index.vue').default})
